export { default as mantra } from './mantra.mp3'
